document.addEventListener('DOMContentLoaded', function() {
    const filterYear = document.querySelector('.js-filter-year');
    const filterTopic = document.querySelector('.js-filter-topic');
    const filterSource = document.querySelector('.js-filter-source');
    const loadMoreButton = document.querySelector('.js-load-more-button');
    const articlesSet = document.querySelector('[data-articles-set]');
    const paginateBy = articlesSet ? parseInt(articlesSet.getAttribute('data-articles-set')) : 2;

    // Sort articles newest first, using the visible date (e.g. "JAN 17, 2024"); undated articles go last
    const months = { JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5, JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11 };

    function getArticleTime(article) {
        const dateEl = article.querySelector('.wls-press-archive__article-date');
        const match = dateEl ? dateEl.textContent.trim().toUpperCase().match(/^([A-Z]{3})\w*\s+(\d{1,2}),\s*(\d{4})$/) : null;
        if (!match || !(match[1] in months)) return null;
        return new Date(parseInt(match[3]), months[match[1]], parseInt(match[2])).getTime();
    }

    const articles = Array.from(document.querySelectorAll('.js-press-archive-article'))
        .map(function(article) { return { el: article, time: getArticleTime(article) }; })
        .sort(function(a, b) {
            if (a.time === null && b.time === null) return 0;
            if (a.time === null) return 1;
            if (b.time === null) return -1;
            return b.time - a.time;
        })
        .map(function(item) { return item.el; });

    if (articlesSet) {
        const loadMoreWrapper = articlesSet.querySelector('.wls-press-archive__articles-load-more');
        articles.forEach(function(article) {
            articlesSet.insertBefore(article, loadMoreWrapper);
        });
    }

    function filterArticles() {
        const selectedYear = filterYear ? filterYear.value : '';
        const selectedTopic = filterTopic ? filterTopic.value : '';
        const selectedSource = filterSource ? filterSource.value : '';

        let visibleCount = 0;

        articles.forEach(function(article) {
            const articleYear = article.getAttribute('data-article-date') || '';
            const articleTopic = article.getAttribute('data-article-topic') || '';
            const articleSource = article.getAttribute('data-article-source') || '';

            const yearMatch = !selectedYear || articleYear === selectedYear;
            const topicMatch = !selectedTopic || articleTopic === selectedTopic;
            const sourceMatch = !selectedSource || articleSource === selectedSource;

            if (yearMatch && topicMatch && sourceMatch) {
                article.classList.remove('wls-press-archive__article--visible');
                article.style.display = '';
                
                // Show articles up to paginateBy limit
                if (visibleCount < paginateBy) {
                    article.classList.add('wls-press-archive__article--visible');
                    visibleCount++;
                }
            } else {
                article.classList.remove('wls-press-archive__article--visible');
                article.style.display = 'none';
            }
        });

        // Show/hide load more button based on remaining visible articles
        if (loadMoreButton) {
            const totalVisible = Array.from(articles).filter(function(article) {
                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                return yearMatch && topicMatch && sourceMatch;
            }).length;

            if (totalVisible > paginateBy) {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = '';
            } else {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = 'none';
            }
        }
    }

    // Add event listeners to filters
    if (filterYear) {
        filterYear.addEventListener('change', filterArticles);
    }
    if (filterTopic) {
        filterTopic.addEventListener('change', filterArticles);
    }
    if (filterSource) {
        filterSource.addEventListener('change', filterArticles);
    }

    // Load more functionality
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function() {
            const selectedYear = filterYear ? filterYear.value : '';
            const selectedTopic = filterTopic ? filterTopic.value : '';
            const selectedSource = filterSource ? filterSource.value : '';

            const currentlyVisible = document.querySelectorAll('.js-press-archive-article.wls-press-archive__article--visible').length;
            let shownCount = 0;

            articles.forEach(function(article) {
                if (shownCount >= paginateBy) return;

                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                if (yearMatch && topicMatch && sourceMatch) {
                    if (!article.classList.contains('wls-press-archive__article--visible')) {
                        article.classList.add('wls-press-archive__article--visible');
                        shownCount++;
                    }
                }
            });

            // Hide load more button if all matching articles are shown
            const totalVisible = Array.from(articles).filter(function(article) {
                const articleYear = article.getAttribute('data-article-date') || '';
                const articleTopic = article.getAttribute('data-article-topic') || '';
                const articleSource = article.getAttribute('data-article-source') || '';

                const yearMatch = !selectedYear || articleYear === selectedYear;
                const topicMatch = !selectedTopic || articleTopic === selectedTopic;
                const sourceMatch = !selectedSource || articleSource === selectedSource;

                return yearMatch && topicMatch && sourceMatch;
            }).length;

            const currentlyVisibleAfter = document.querySelectorAll('.js-press-archive-article.wls-press-archive__article--visible').length;

            if (currentlyVisibleAfter >= totalVisible) {
                loadMoreButton.closest('.wls-press-archive__articles-load-more').style.display = 'none';
            }
        });
    }

    // Apply the initial page of visible articles in the new sorted order
    filterArticles();
});

